export default {
  playSvgFill: {
    fill: data => data.color,
  },
};



// WEBPACK FOOTER //
// ./default-modules/ui/controls/play/play.theme.ts